<template>
    <div>
        <h1 class="headline font-weight-light mb-3">Knowledge</h1>
        <v-card>
            <v-card-title>
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    @keyup="getAjax()"
                ></v-text-field>
                <v-spacer></v-spacer>
            </v-card-title>
        </v-card>
        <v-card
            outlined
            class="mx-auto"
            v-for="(items, i) in data"
            :key="i"
            @click="showcontent(items)"
        >
            <!-- pl-12 pr-12 -->

            <div
                class="card"
                @mouseover="mouseOver(i)"
                @mouseleave="mouseleave(i)"
                :class="items.button ? 'activediv' : ''"
            >
                <v-row>
                    <v-col style="margin-left:40px;">
                        <h4
                            style="font-size: 1.5rem !important;font-weight: 400;line-height: 2rem;letter-spacing: normal !important;"
                        >
                            {{ items.title }}
                        </h4>

                        <span
                            :class="
                                items.button ? 'activediv' : 'fix-color-font'
                            "
                            v-if="items.keywords.length > 0"
                            v-for="(items1, i1) in items.keywords"
                            :key="i1"
                            style="font-size: 1rem !important;
    font-weight: 400;
    letter-spacing: 0.009375em !important;
    line-height: 1.75rem;"
                            ><label v-if="i1 != 0">,</label
                            >{{ items1.keyword_name }}</span
                        >
                    </v-col>
                </v-row>
            </div>
        </v-card>

        <div class="text-center pb-5 pt-4">
            <div>
                <v-btn class="mx-2" fab small @click="backreceive()">
                    <v-icon dark small>mdi-chevron-left</v-icon>
                </v-btn>

                <v-btn
                    class="mx-2"
                    fab
                    small
                    :color="btn_color(n)"
                    v-for="n in page_count"
                    :key="n"
                    @click="getpage(page_num_show(n))"
                    >{{ page_num_show(n) }}</v-btn
                >

                <v-btn class="mx-2" fab small @click="next()">
                    <v-icon dark small>mdi-chevron-right</v-icon>
                </v-btn>
            </div>
        </div>

        <v-dialog max-width="500" v-model="dialogcontent">
            <v-card>
                <v-card-title class="headline">
                    {{ content.title }}
                </v-card-title>
                <v-card-subtitle class="subtitle-1">
                    <p class="mt-2">
                        <v-chip small class="mr-1">{{
                            content.created_name + " : " + content.created_date
                        }}</v-chip>
                    </p>
                    {{ content.subtitle }}
                </v-card-subtitle>
                <v-card-text class="subtitle-3" v-html="content.content">
                </v-card-text>
                <v-container fluid>
                    <v-row v-viewer>
                        <v-col cols="3">
                            <template v-if="image.images.length > 0">
                                <view-image title="image" :data="image" />
                            </template>
                        </v-col>
                    </v-row>
                </v-container>

                <v-card-actions>
                    <div
                        v-for="(itemeditpic, idxeditpic) in content.files"
                        :key="idxeditpic"
                    >
                        <v-chip
                            small
                            class="mr-2 mb-2"
                            :href="
                                showpic +
                                    itemeditpic.file_store_name +
                                    '/' +
                                    itemeditpic.file_name
                            "
                            target="_blank"
                        >
                            <v-avatar left>
                                <v-icon small>mdi-paperclip</v-icon> </v-avatar
                            >{{ itemeditpic.file_name }}
                        </v-chip>
                    </div>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="cancelcontent()"
                        >Close</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"
export default {
    mounted() {
        this.getAjax()
    },
    data() {
        return {
            active: false,
            hover: false,
            dialogcontent: false,
            content: [],
            datapage: [],
            page_total: 0,
            page_count: 0,

            showpic: `${process.env.VUE_APP_ROOT_API}/api/announce/attachments/`,
            cycle: true,
            search: "",
            image: {
                images: [],
            },
            data: [],
        }
    },
    methods: {
        mouseOver: function(i) {
            this.data[i].button = true
        },
        mouseleave: function(i) {
            this.data[i].button = false
        },
        cancelcontent() {
            this.content = []
            this.dialogcontent = false
        },
        showcontent(a) {
            this.dialogcontent = true
            // console.log(a, "dsdsad");
            this.content = { ...a }
            this.image.images = []
            a.images.map((each) => {
                this.image.images.push(each)
            })

            // console.log(this.content1, "content1");
            // console.log(this.image, "image");
        },
        async getpage(num) {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            if (num != "...") {
                this.current_page = num
                let url =
                    `${process.env.VUE_APP_ROOT_API}/api/knowledge?page=` + num
                let { data } = await axios.post(url, {})
                var sent = {
                    button: false,
                }
                this.datapage = data
                this.data = []
                data.data.map((each) => {
                    var ob = [...each.images]
                    this.image.images = []
                    ob.map((src) => {
                        this.image.images.push(
                            this.showpic +
                                src.file_store_name +
                                "/" +
                                src.file_name
                        )
                    })
                    this.data.push(Object.assign({}, each, this.image, sent))
                })
                // console.log(this.data, "dsad");
            }
        },
        btn_color(n) {
            if (this.page_count == 7) {
                if (this.datapage.current_page <= 4) {
                    return this.datapage.current_page === n ? "primary" : ""
                } else if (
                    this.datapage.current_page == this.datapage.last_page
                ) {
                    return n === 7 ? "primary" : ""
                } else if (
                    this.datapage.current_page ==
                    this.datapage.last_page - 1
                ) {
                    return n === 6 ? "primary" : ""
                } else if (
                    this.datapage.current_page ==
                    this.datapage.last_page - 2
                ) {
                    return n === 5 ? "primary" : ""
                } else {
                    return n === 4 ? "primary" : ""
                }
            } else {
                return this.datapage.current_page === n ? "primary" : ""
            }
        },
        page_num_show(n) {
            let page = n
            if (this.page_count == 7) {
                let chk2 = 0
                let chk3 = 0
                let chk4 = 0
                let chk5 = 0
                let chk6 = 0
                if (this.datapage.current_page == 1) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.datapage.last_page - 1
                } else if (
                    this.datapage.current_page == this.datapage.last_page
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.datapage.last_page - 3
                    chk5 = this.datapage.last_page - 2
                    chk6 = this.datapage.last_page - 1
                } else if (this.datapage.current_page == 2) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.datapage.last_page - 1
                } else if (
                    this.datapage.current_page ==
                    this.datapage.last_page - 1
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.datapage.last_page - 3
                    chk5 = this.datapage.last_page - 2
                    chk6 = this.datapage.last_page - 1
                } else if (this.datapage.current_page == 3) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.datapage.last_page - 1
                } else if (
                    this.datapage.current_page ==
                    this.datapage.last_page - 2
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.datapage.last_page - 3
                    chk5 = this.datapage.last_page - 2
                    chk6 = this.datapage.last_page - 1
                } else {
                    chk2 = "..."
                    chk3 = this.datapage.current_page - 1
                    chk4 = this.datapage.current_page
                    chk5 = this.datapage.current_page + 1
                    chk6 = "..."
                }

                n === 1 ? (page = 1) : ""
                n === 2 ? (page = chk2) : ""
                n === 3 ? (page = chk3) : ""
                n === 4 ? (page = chk4) : ""
                n === 5 ? (page = chk5) : ""
                n === 6 ? (page = chk6) : ""
                n === 7 ? (page = this.datapage.last_page) : ""
            } else {
                n === 1 ? (page = 1) : ""
                n === 2 ? (page = 2) : ""
                n === 3 ? (page = 3) : ""
                n === 4 ? (page = 4) : ""
                n === 5 ? (page = 5) : ""
                n === 6 ? (page = 6) : ""
            }
            return page
        },
        async getAjax() {
            const url = `${process.env.VUE_APP_ROOT_API}/api/knowledge`
            try {
                var sent = {
                    button: false,
                }
                const { data } = await axios.post(url, {
                    searchtext: this.search,
                })
                this.datapage = data
                this.page_total = data.last_page
                this.page_total < 7
                    ? (this.page_count = this.page_total)
                    : (this.page_count = 7)
                this.data = []
                data.data.map((each) => {
                    var ob = [...each.images]
                    this.image.images = []
                    ob.map((src) => {
                        this.image.images.push(
                            this.showpic +
                                src.file_store_name +
                                "/" +
                                src.file_name
                        )
                    })
                    this.data.push(Object.assign({}, each, this.image, sent))
                })
                // console.log(this.data, "data");
            } catch (error) {
                console.log(error)
            }
        },
    },
}
</script>
<style>
.v-carousel__controls {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.3);
    bottom: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;

    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    list-style-type: none;
    position: absolute;
    width: 100%;
    /* z-index: 1; */
    height: 30px;
}
</style>
<style scoped>
.activediv {
    background: grey;
    color: white;
}
.image {
    display: none;
}
.fix-color-font {
    color: #000000 !important;
}
</style>
